module.exports = __webpack_public_path__ + "static/media/Portrait-10030.f5d00183.jpg";